export default __webpack_public_path__ + "static/media/yahoo.cb26ed0e.svg";